import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logOut, setSession } from '@stb-module-auth/actions';
import { useAxios4 } from '.';

export const useValidateToken = () => {
  const dispatch = useDispatch();
  const [validateToken] = useAxios4(
    '/v1/auth/validate-device-token',
    'post',
    true // withAuthorization true
  );

  useEffect(() => {
    validateToken({ device_token: '-' })
      .then((res) => {
        // Valid
      })
      .catch((err) => {
        // Not valid
        dispatch(setSession({ key: 'user', data: null }));
        dispatch(logOut());
      });
  }, []);
};
